import React from "react";

export default function FieldPopover_InlineValueNotEmpty(props:any) {

    const valueClasses = Classes("ui5-txt-default ui5-field-dropdown-inline-editable", props.className)


    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {_.get(props.field.components, 'ValuePrefix', false)}
                {props.field.getDisplayValue(props.value)}
            </div>
            {props.children}
        </React.Fragment>
    );
}
